const PlayIconPure = ({
  width = '15',
  height = '15',
  viewBox = '0 0 13 15',
}: {
  width?: string;
  height?: string;
  viewBox?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 1.30205V13.6939C0.751837 13.7928 0.779714 13.8895 0.830819 13.9741C0.881925 14.0588 0.954453 14.1285 1.04109 14.1762C1.12773 14.2239 1.22541 14.2479 1.32429 14.2459C1.42317 14.2438 1.51975 14.2156 1.6043 14.1643L11.7349 7.96838C11.8158 7.9194 11.8828 7.85038 11.9292 7.76797C11.9757 7.68557 12.0001 7.59258 12.0001 7.49799C12.0001 7.4034 11.9757 7.31041 11.9292 7.22801C11.8828 7.14561 11.8158 7.07658 11.7349 7.0276L1.6043 0.831663C1.51975 0.78034 1.42317 0.752216 1.32429 0.750126C1.22541 0.748035 1.12773 0.772053 1.04109 0.819757C0.954453 0.867461 0.881925 0.937165 0.830819 1.02184C0.779714 1.10652 0.751837 1.20317 0.75 1.30205Z"
        stroke="#848484"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PlayIconPure;
